<template>
  <div>
    <div class="px-3">
      <FilterWrapper>
        <template slot="filterForm">
          <CouponFilter
            :loading="loading"
            :rLoading="rLoading"
            :submitFilter="refetch"
            :clearFilter="() => clearFilter('couponRef')"
          />
        </template>
      </FilterWrapper>
    </div>
    <TableWrapper
      :loading="loading"
      :errorMsg="errorMsg"
      :refetch="fetchMerchantCoupons"
      :isEmpty="isEmpty"
      :emptyTitle="emptyTitle"
    >
      <div class="w-100 py-3" slot="content">
        <v-server-table
          ref="couponRef"
          class="v-table row-pointer"
          :data="customers"
          :columns="columns"
          :options="options"
          @loaded="onLoaded"
        >
          <template slot="createdAt" slot-scope="{ row }">
            {{ row.createdAt | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <template slot="discountType" slot-scope="{ row }">
             {{titleCase(row.discountType)}} 
          </template>
          <template slot="startDate" slot-scope="{ row }">
            {{ row.startDate | moment(" MM-DD-YYYY h:mm a") }}
          </template>
          <template slot="endDate" slot-scope="{ row }">
            {{ row.endDate | moment(" MM-DD-YYYY h:mm a") || 'N/A' }}
          </template>
        </v-server-table>
      </div>
    </TableWrapper>
  </div>
</template>

<script>
import { componentData } from "../../../../../../public/assets/mixins/componentData";
import TableWrapper from "../../../../../components/utils/TableWrapper/TableWrapper.vue";
import CouponFilter from "../../../../../components/filters/CouponFilter";

const plansHeadings = {
  couponCode: "Coupon Code",
  discountType: "Discount Type",
  discountValue: "Discount",
  createdAt: "Date Created",
  startDate: "Start Date",
  endDate: "End Date",
};

export default {
  name: "Coupons",
  mixins: [componentData],
  data() {
    return {
      singleInviteObj: null,
      showSingleInviteModal: false,
      emptyTitle: "No Coupon Found",
      showInviteModal: false,
      loading: false,
      errorMsg: "",
      customers: [],
      ...this.tableOptions(plansHeadings, 25),
    };
  },
  components: {
    TableWrapper,
    CouponFilter,
  },
  methods: {
    async fetchMerchantCoupons() {
      this.options.requestFunction = async (data) => {
        const params = { ...data, ...this.filters, id: this.clientid, size: 25 };
        const response = await this.$store.dispatch(
          "customer/getPaymentMerchantCoupons",
          {
            params,
          }
        );

        const newData = response.data.data;
        const count = response.data.count;
        return { ...response, count, total: count, data: newData };
      };
    },
    refetch(filters) {
      this.handleRefetch(filters, this.fetchMerchantCoupons, "couponRef");
    },
  },

  props: ["clientid"],
  created() {
    this.fetchMerchantCoupons();
  },
  mounted() {
    this.columns = Object.keys(plansHeadings).map((keyVal) => keyVal);
  },
};
</script>
